import { useNavigate } from "react-router-dom";
import FONDO from "../assets/inicio.png";

const SectionOne = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/services");
  };

  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 flex justify-center items-center">
        <img
          src={FONDO}
          alt="Inicio"
          className="h-full w-auto object-contain"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col justify-center p-8 md:p-16 bg-white">
        <h1 className="text-3xl md:text-5xl font-bold text-purple-900">
          ALIADOS EN CONSULTORÍA DE EMPRESAS
        </h1>
        <p className="mt-6 text-gray-600 text-base md:text-lg">
          Somos una firma dedicada a la asesoría y consultoría empresarial para las áreas estratégicas de su negocio.
        </p>
        <button
          onClick={handleClick}
          className="mt-8 bg-gray-500 text-white rounded-full px-6 py-3 hover:bg-purple-800 transition"
        >
          Ver todos los servicios
        </button>
      </div>
    </div>
  );
};

export default SectionOne;
